import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

export const bnplPayload: BuyNowPayLaterMethod[] = [
  {
    logo: {
      logoLight: require('../../assets/img/fakeMethodLogo1.svg').default,
      logoDark: require('../../assets/img/fakeMethodLogoDark1.svg').default,
    },
    paymentMethod: 'fakeMethod1',
    paymentOptions: [],
    bnplMessage: 'or 4 interest-free payments of $100.00 with',
    bnplModalPage: {
      ctaText: 'Learn more',
      resolution: {
        width: 100,
        height: 100,
      },
    },
  },
  {
    logo: {
      logoLight: require('../../assets/img/fakeMethodLogo2.svg').default,
      logoDark: require('../../assets/img/fakeMethodLogoDark2.svg').default,
    },
    paymentMethod: 'fakeMethod2',
    paymentOptions: [],
    bnplMessage: 'or 6 weekly interest-free payments from $66.50 with',
    bnplModalPage: {
      ctaText: 'Learn more',
      resolution: {
        width: 100,
        height: 100,
      },
    },
  },
];
